var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var GroupElement_1;
import { JSON, JsonDiscriminatorValue, JsonSchema } from '@symon-ai/wisepipe-serialize';
import { GraphElement } from './graphElement';
const schema = {
    $id: 'urn:wisepipe-common-pipe:GroupElement',
    type: 'object',
    properties: {
        x: { type: 'number', minimum: -100000, maximum: 100000 },
        y: { type: 'number', minimum: -100000, maximum: 100000 },
        name: { type: 'string' }
    }
};
let GroupElement = GroupElement_1 = class GroupElement extends GraphElement {
    constructor(elementID, 
    // optional so they don't have to be included if updating group that hasn't changed position
    x, y, name, lastModified, uniqueChangeID) {
        super(elementID, 'group', lastModified, uniqueChangeID);
        this.x = x;
        this.y = y;
        if (name !== undefined)
            this.name = name;
        JSON.validate(this, GroupElement_1);
    }
};
GroupElement = GroupElement_1 = __decorate([
    JsonSchema(schema),
    JsonDiscriminatorValue('group')
], GroupElement);
export { GroupElement };
//# sourceMappingURL=groupElement.js.map